import React from 'react';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string | null;
  hint?: string;
}

export const Input: React.FC<Props> = ({
  label,
  error,
  hint,
  style,
  ...rest
}) => {
  return (
    <label
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 6,
        fontSize: 13,
        color: 'var(--text-secondary)',
      }}
    >
      {label ? <span style={{ fontWeight: 500 }}>{label}</span> : null}
      <input
        {...rest}
        style={{
          height: 42,
          padding: '0 14px',
          borderRadius: 'var(--radius-md)',
          border: `1px solid ${error ? 'var(--error)' : 'var(--border)'}`,
          background: 'var(--bg-card)',
          color: 'var(--text-primary)',
          fontSize: 14,
          outline: 'none',
          transition: 'border-color 120ms ease',
          ...style,
        }}
      />
      {error ? (
        <span style={{ color: 'var(--error)', fontSize: 12 }}>{error}</span>
      ) : hint ? (
        <span style={{ color: 'var(--text-muted)', fontSize: 12 }}>{hint}</span>
      ) : null}
    </label>
  );
};
